<ng-progress ngProgressRouter #progressBar />
<router-outlet></router-outlet>